import { baseMoment } from './dates';

export const visaInvitationLinkEnabled = (visaFields) => {
  const {
    firstName,
    lastName,
    birthdate,
    jobTitle,
    passportNumber,
    passportExpiryDate,
    // checkinDate,
    // checkoutDate,
    // hotel,
  } = visaFields;

  return (
    !!firstName
    && !!lastName
    && !!birthdate
    && !!jobTitle
    && !!passportNumber
    && !!passportExpiryDate
    // && !!checkinDate
    // && !!checkoutDate
    // && !!hotel
  );
};

export const downloadVisaInvitationLink = (visaFields) => {
  const baseUrl = 'https://cartier-worlds-meeting-forum-rooming.fly.dev/api/events/0bdc99be-9126-479f-b4e0-3ad3d78ce560/download-visa';

  const {
    firstName,
    lastName,
    birthdate,
    jobTitle,
    company,
    passportNumber,
    passportExpiryDate,
    checkinDate,
    checkoutDate,
    hotel,
    zoneDetails,
  } = visaFields;

  const params = [];

  if (firstName || lastName) params.push(
    `full_name=${encodeURIComponent((`${firstName} ${lastName}`).trim())}`
  );

  if (birthdate) params.push(
    `birthdate=${encodeURIComponent(baseMoment(birthdate).format('LL'))}`
  );

  if (jobTitle) params.push(
    `position=${encodeURIComponent(jobTitle)}`
  );

  if (company) params.push(
    `company=${encodeURIComponent(company)}`
  );

  if (passportNumber) params.push(
    `passport_number=${encodeURIComponent(passportNumber)}`
  );

  if (passportExpiryDate) params.push(
    `passport_expiry_date=${encodeURIComponent(baseMoment(passportExpiryDate).format('LL'))}`
  );

  if (checkinDate) params.push(
    `checkin_date=${encodeURIComponent(baseMoment(checkinDate).format('LL'))}`
  );

  if (checkoutDate) params.push(
    `checkout_date=${encodeURIComponent(baseMoment(checkoutDate).format('LL'))}`
  );

  if (hotel) params.push(
    `hotel_name=${encodeURIComponent(hotel)}`
  );

  if (zoneDetails) params.push(
    `zone_details=${encodeURIComponent(zoneDetails)}`
  );

  return `${baseUrl}?${params.join('&')}`;
};
